export default __webpack_public_path__ + "static/media/employees_2.d18f7035.png";